import cx from "classnames";

import ButtonGroup from "./ButtonGroup";

import styles from "./Actions.module.scss";

interface ActionsProps {
  children: React.ReactNode;
  className?: string;
}

const Actions = ({ children, className }: ActionsProps) => {
  return (
    <div className={cx(styles.actions, className)}>
      <ButtonGroup className={styles.buttons}>{children}</ButtonGroup>
    </div>
  );
};

export default Actions;
